import axios from "axios";
import { listRequestBody } from "../utils/listPagination";

const BASE = "/api/topics";

export const BULK_UPLOAD_ENDPOINT = `${BASE}/bulk-upload`;

export function list(options = {}) {
  return axios.post(`${BASE}/list`, listRequestBody(options));
}

export function create(data) {
  return axios.post(BASE, data);
}

export function update(id, { field, value }) {
  return axios.patch(`${BASE}/${id}`, { field, value });
}

export function remove(id) {
  return axios.delete(`${BASE}/${id}`);
}

function listQueryFromOptions(options = {}) {
  const body = listRequestBody(options);
  const params = { page: body.page, limit: body.limit };
  if (body.export) {
    params.export = "1";
    params.all = "1";
  }
  return params;
}

export function bySubject(subjectId, options = {}) {
  return axios.get(`${BASE}/by-subject/${subjectId}`, {
    params: listQueryFromOptions(options),
  });
}

export function bySubjectAndGrade(subjectId, gradeId, options = {}) {
  return axios.get(`${BASE}/by-subject/${subjectId}/${gradeId}`, {
    params: listQueryFromOptions(options),
  });
}
